import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
      <Weather defaultCity ="Johannesburg" />
      <footer>
      This page is coded by {" "}
        <a
          href="https://www.linkedin.com/in/keesha-kallasur-a123221b6"
          target="_blank"
          rel="noreferrer"
        >
      Keesha Kallasur
        </a>{" "}
      open sourced on{" "}
        <a
          href="https://github.com/keeshakal/weather-react-app"
          target="_blank"
          rel="noreferrer"
        >
        {" "}
      GitHub
        </a>{" "}
      hosted on{" "}
        <a
          href="https://master--coruscating-kataifi-71c9e0.netlify.app/"
          target="_blank"
          rel="noreferrer"
        >
      Netlify.
        </a>
    </footer>
          </div>
    </div>
  );
}